import React, { createContext, useState, ReactNode, useContext } from 'react';

interface RootContextProps {
  // Define your context properties here
}

const RootContext = createContext<RootContextProps | undefined>(undefined);

export const RootProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Define your state and context values here

  return (
    <RootContext.Provider value={{ /* context values */ }}>
      {children}
    </RootContext.Provider>
  );
};

export const useRootContext = () => {
  const context = useContext(RootContext);
  if (context === undefined) {
    throw new Error('useRootContext must be used within a RootProvider');
  }
  return context;
};